import type { TypedAnalyticsContexts } from '@/analytics/snowplow/analytics-context.types';
import { AnalyticsTrackingProvider, useAnalyticsTracking } from '@/analytics/snowplow/AnalyticsTrackingContext';
import { buildContextId } from '@/analytics/snowplow/utils/buildContextId';
import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { useScheduledConsultId } from '../hooks/useScheduledConsultId';

interface BaseAnalyticsContextProps {
  children: ReactNode;
}

export const BaseAnalyticsContext = ({ children }: BaseAnalyticsContextProps) => {
  const scheduledConsultId = useScheduledConsultId();
  const { uiEvent } = useAnalyticsTracking();

  const updateTrackingContext = useCallback(
    (ctx: TypedAnalyticsContexts): TypedAnalyticsContexts => ({
      ...ctx,
      uiEvent: {
        ...uiEvent,
        context_id: buildContextId('scheduled_consult_tab'),
      },
      ...(scheduledConsultId && {
        consultation: { ...ctx.consultation, consultation_id: scheduledConsultId.toString() },
      }),
    }),
    [uiEvent, scheduledConsultId],
  );

  return <AnalyticsTrackingProvider update={updateTrackingContext}>{children}</AnalyticsTrackingProvider>;
};
